module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-180x180-aec975e2d3f5a50684f05ce443412778.png";